import React from "react";
import { motion } from "framer-motion";
import { EnvelopeSimple, Phone } from "@phosphor-icons/react";
import { PARTNERS } from "../lib/practiceAreas";

export const Team = () => {
  return (
    <section
      id="team"
      data-testid="team-section"
      className="relative py-24 md:py-32 bg-[#0B0B0E] border-t border-white/5 section-light"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-12 bg-[#E9C76A]" />
              <span className="overline">Partners</span>
            </div>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[#F5F2E8]">
              Led by partners.
              <br />
              <span className="italic text-[#E9C76A]">Answered</span> by partners.
            </h2>
          </div>
          <div className="lg:col-span-5 lg:col-start-8 self-end">
            <p className="text-base md:text-lg text-white/60 font-light leading-relaxed">
              When you instruct Lawfields, your matter is handled by a partner —
              not passed to a junior. That&apos;s our promise.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-10">
          {PARTNERS.map((p, idx) => (
            <motion.div
              key={p.email}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: idx * 0.15 }}
              data-testid={`partner-${p.email}`}
              className="border border-white/10 bg-[#14141A] p-8 md:p-10 glass-card transition-colors"
            >
              <div className="flex items-start gap-6">
                <div className="w-20 h-20 flex-shrink-0 border border-[#E9C76A]/40 bg-[#0F0F0F] flex items-center justify-center">
                  <span className="font-serif text-2xl text-[#E9C76A]">
                    {p.initials}
                  </span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="overline">{p.role}</div>
                  <h3 className="font-serif text-3xl text-[#F5F2E8] mt-2 mb-6 tracking-tight">
                    {p.name}
                  </h3>

                  <div className="space-y-3 text-sm">
                    <a
                      href={`mailto:${p.email}`}
                      className="flex items-center gap-3 text-white/70 hover:text-[#E9C76A] transition-colors break-all"
                    >
                      <EnvelopeSimple size={16} weight="thin" className="text-[#E9C76A] flex-shrink-0" />
                      {p.email}
                    </a>
                    <a
                      href={`tel:${p.mobile.replace(/\s/g, "")}`}
                      className="flex items-center gap-3 text-white/70 hover:text-[#E9C76A] transition-colors"
                    >
                      <Phone size={16} weight="thin" className="text-[#E9C76A] flex-shrink-0" />
                      {p.mobile}
                    </a>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
